module.exports = __webpack_public_path__ + "assets/img/ifood.cc7faca5.svg";